import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import TableSetQueryGraphQL from './TableSet.query.graphql';
import TableSet from '@/components/TableSet/TableSet.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableSetReference',
  props: {
    tableSetId: {}
  },
  setup(__props: any) {

const props = __props;

const { result: queryResult } = useQuery(TableSetQueryGraphQL, {
  path: props.tableSetId,
});

const tableSet = computed(() => {
  return {
    rows: queryResult.value?.item?.children?.map((row: any) => {
      return {
        title: row.title,
        cols: row.children?.map((col: any) => {
          return {
            text: col.text,
          };
        }),
      };
    }),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableSet, { tableSet: tableSet.value }, null, 8, ["tableSet"]))
}
}

})